<template>
  <div class="nav-common" :class="isTop ? 'nav-top' : 'nav-fix'">
    <header-view :show-style="showStyleValue" />
  </div>
</template>

<script>
import HeaderView from "@/views/HeaderView";
import { computed, onMounted, onUnmounted, ref } from "vue";

export default {
  name: "HomeNav",
  components: {
    HeaderView,
  },
  setup() {
    const isTop = ref(true);
    let handleScroll = function handleScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop >= 55) {
        isTop.value = false;
      } else {
        isTop.value = true;
      }
    };
    onMounted(() => {
      window.addEventListener("scroll", handleScroll);
    });

    onUnmounted(() => {
      window.removeEventListener("scroll", handleScroll);
    });

    let showStyleValue = computed(() => {
      return isTop.value === true ? 0 : 1;
    });

    return {
      showStyleValue,
      isTop,
    };
  },
};
</script>

<style>
.nav-common {
  z-index: 100;
  width: 100%;
}

.nav-top {
  position: fixed;
  background: transparent;
}

.nav-fix {
  position: fixed;
  background-color: white;
  border-bottom: 1px solid #dbdcdd;
}
</style>
